import React from 'react';

import CmsArticle from './CmsArticle';
import JobAd from './JobAd';
import { Recommendation } from '../../types'

type AdsProps = {
    items: Recommendation[];
    imagesCdnUrl: string;
}

const Ads: React.FC<AdsProps> = (props) => {
    const {
        items,
        imagesCdnUrl
    } = props;

    return (
        <div className="grid f-grid grid-cols-2 gap-16 md:grid-cols-2 lg:grid-cols-3 mx-20 my-32">
            {items.map((item) => {
                switch (item.renderType) {
                    case "CMS":
                        return (
                            <CmsArticle
                                item={item}
                            />
                        );
                    default:
                        // JOB
                        return (
                            <JobAd
                                item={item}
                                imagesCdnUrl={imagesCdnUrl}
                            />
                        );
                }
            })}
        </div>
    );
};

export default Ads;
